/**
 * Decorates the ngFormDirective so that the control group directives
 * get passed a reference to the ngModelCtrl that is used by the input. This is
 * needed to determine if the input is pristine.
 */
import _ from 'underscore';

export default ['$delegate', function ($delegate) {
    var directive = $delegate[0];
    var origControllerCtr = directive.controller;

    directive.controller = ['$scope', '$element', '$attrs', '$injector', function ($scope, $element, $attrs, $injector) {
        var self = this;
        this._inputModelValidationFns = [];
        this._setPristineFns = [];

        function removeListeners(validationListener, setPristineListener) {
            var idx = self._inputModelValidationFns.indexOf(validationListener);
            if (idx >= 0) {
                self._inputModelValidationFns.splice(idx, 1);
            }
            idx = self._setPristineFns.indexOf(setPristineListener);
            if (idx >= 0) {
                self._setPristineFns.splice(idx, 1);
            }
        }

        /**
         * Register a control with a form so that we can mark a form
         * as valid or pristine based on the pristine and validity values
         * of each control.
         *
         * @param {Function} validtyFn : Function to get the validity value of a control
         * @param {Function} setPristineFn : Function to mark a control as pristine
         *
         * @returns {Function}
         */
        this.addModelControl = function (validtyFn, setPristineFn) {
            self._inputModelValidationFns.push(validtyFn);
            self._setPristineFns.push(setPristineFn);
            return _.partial(removeListeners, validtyFn, setPristineFn);
        };

        /**
         * Set all controls registered with a form to pristine
         */
        this.setPristine = function () {
            self._setPristineFns.forEach(function (setCtrlToPristine) {
                setCtrlToPristine();
            });
        };

        Object.defineProperty(self, 'valid', {
            get: function get() {
                return _.every(self._inputModelValidationFns, function (validFn) {
                    return validFn();
                });
            }
        });
        Object.defineProperty(self, 'invalid', {
            get: function get() {
                return !self.valid;
            }
        });
        // call the original controller with the correct DI services passed in
        $injector.invoke(origControllerCtr, this, {
            $scope: $scope,
            $element: $element,
            $attrs: $attrs
        });
    }];
    return $delegate;
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/basicinputs/NgFormDecorator.js
// module id = 767
// module chunks = 0